import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from "react-i18next"
import { M_InputTextField, M_Button, M_TransferList, BufferService, M_DrawerTableTextField, LoadingContext, M_StateActions, M_Header } from 'src/components/M_Components'
import { useDispatch, useSelector } from 'react-redux'
import './pages.css'

export const UserConfigCrud = ({ handleTabClose }) => {
  const dispatch = useDispatch()
  const M_State = useSelector((state) => state.StateKeyValue)

  const { t } = useTranslation()
  const ctx = useContext(LoadingContext)
  const passOperation = M_State.filter(obj => obj.key === 'operation')[0]?.value !== null ? M_State.filter(obj => obj.key === 'operation')[0]?.value : 'Error'
  const sessionLine = M_State.filter(obj => obj.key === 'UserLine')[0]?.value !== null && M_State.filter(obj => obj.key === 'UserLine')[0]?.value !== undefined ? M_State.filter(obj => obj.key === 'UserLine')[0]?.value : 'Error'
  const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
  const [operation, setOperation] = useState(passOperation)
  const [passLine, setPassLine] = useState('')
  const [userInfo, setUserInfo] = useState({})
  const [roles, setRoles] = useState([])
  const [userRoles, setUserRoles] = useState([])
  const [isFirst, setIsFirst] = useState(true)
  const [userType, setUserType] = useState(null)
  const isView = operation === 'View'
  const bufferServiceUser = new BufferService('identity/register')
  const bufferServiceGetuser = new BufferService('identity/registerextras')
  const bufferServiceUpdateUser = new BufferService('identity/updateuser')
  const sessionKeys = ['passLine', 'operation', 'userInfo', 'roles', 'userRoles', 'isFirst', 'userType']

  useEffect(() => {
    if (isFirst) {
      dispatch(M_StateActions.removeM_State({ key: 'operation' }))
      dispatch(M_StateActions.removeM_State({ key: 'UserLine' }))
      dispatch(M_StateActions.removeM_State({ key: 'role' }))
      setPassLine(sessionLine)
      setIsFirst(false)
    }
    getSessionStorageData(id)
    // eslint-disable-next-line
  }, [])

  const sessionStorageMachine = (id, key, value) => {
    let tempObj = {}
    // eslint-disable-next-line
    if (eval(value) instanceof Map) {
      // eslint-disable-next-line
      tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
    } else {
      // eslint-disable-next-line
      tempObj = { key: `${key}`, value: (eval(value)) }
    }
    return tempObj
  }

  // eslint-disable-next-line
  useEffect(() => {
    const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
    if (newId !== id) {
      setId(newId)
      getSessionStorageData(newId)
    }
  })

  useEffect(() => {
    const tempArray = []
    sessionKeys.forEach((key) => {
      tempArray.push(sessionStorageMachine(id, key, key))
    })
    dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
    // eslint-disable-next-line
  }, [id, operation, passLine, userInfo, roles, userRoles, isFirst, userType])

  const getSessionStorageData = (sessionID) => {
    ctx.setIsLoad(true)
    const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
    if (M_StateData) {
      const tempPL = M_StateData.filter(obj => obj.key === `passLine`)[0]?.value
      const tempO = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
      const tempUI = M_StateData.filter(obj => obj.key === `userInfo`)[0]?.value
      const tempR = M_StateData.filter(obj => obj.key === `roles`)[0]?.value
      const tempUR = M_StateData.filter(obj => obj.key === `userRoles`)[0]?.value
      const tempIF = M_StateData.filter(obj => obj.key === `isFirst`)[0]?.value
      const tempUT = M_StateData.filter(obj => obj.key === `userType`)[0]?.value
      if (tempPL || tempO || tempUI || tempR || tempUR || tempIF || tempUT) {
        setPassLine(tempPL)
        setOperation(tempO)
        setUserInfo(tempUI)
        setRoles(tempR)
        setUserRoles(tempUR)
        setIsFirst(tempIF)
        setUserType(tempUT)
        return
      }
    }
    ctx.setIsLoad(false)
    getRefresh(sessionLine)
  }

  const getRefresh = (line) => {
    const lineUser = line ? line : passLine

    if (operation === 'Edit') {
      bufferServiceGetuser.getId(lineUser.Id).then(resUser => {
        if (resUser.name === 'AxiosError') {
          handleTabClose(id)
          ctx.toastMessages('error', '', resUser.message)
          return
        }
        setUserInfo({
          ...resUser,
          ShortName: resUser.ShortName ?? resUser.CustomerName ?? ''
        })
        setUserRoles(resUser.ListRoleId || [])
        setUserType(resUser?.CustomerId ? 'client' : 'internal')
      })
    }
    ctx.setIsLoad(false)
  }

  const onSave = () => {
    ctx.setIsLoad(true)
    if (userType === 'client' && !userInfo?.CustomerId) {
      ctx.toastMessages('error', t("Customer"), t("RequiredField"))
      ctx.setIsLoad(false)
      return
    }

    const User = {
      'username': userInfo.Username,
      'email': userInfo.Email,
      'phoneNumber': userInfo.PhoneNumber,
      'roleId': userRoles.map(r => r.Id),
      'customerId': userInfo.CustomerId,
    }

    console.log("submit", User)
    if (userRoles.length === 0) {
      ctx.toastMessages('error', '', t('NoRole'))
      ctx.setIsLoad(false)
      return
    }

    if (operation === 'Create' || operation === 'Copy') {
      bufferServiceUser.post(User).then(res => {
        if (res.name === 'AxiosError') {
          ctx.setIsLoad(false)
          ctx.toastMessages('error', res.response?.data?.Errors ? res.response.data.Errors : res.message, '')
          return
        }
        ctx.setIsLoad(false)
        handleTabClose(id)
        ctx.toastMessages('success', '', t('UserCreated'))
        return
      })
    }
    if (operation === 'Edit') {
      bufferServiceUpdateUser.update(passLine.Id, User).then(res => {
        if (res.name === 'AxiosError') {
          ctx.setIsLoad(false)
          ctx.toastMessages('error', res.response?.data?.Errors ? res.response.data.Errors : res.message, '')
          return
        }
        ctx.setIsLoad(false)
        handleTabClose(id)
        ctx.toastMessages('success', '', t('UserUpdated'))
        return
      })
    }
  }

  return (
    <div>
      <M_Header
        element={
          <>
            <M_Button
              tooltip={t("RefreshTable")}
              icon={<i className="pi pi-refresh iconTable"></i>}
              label={<b>{t("RefreshTable")}</b>}
              onClick={() => getRefresh()}
            />
            {operation !== 'View' ?
              <M_Button
                tooltip={t("Save")}
                icon={<i className="pi pi-save iconTable"></i>}
                label={<b>{t("Save")}</b>}
                onClick={() => {
                  if (!userType) {
                    ctx.toastMessages('error', '', t('SelectUserType'))
                    return
                  }
                  onSave()
                }}
              />
              : ''}
          </>
        }
      />
      <div className='divGlobalCreateUser'>
        <div>
          <b style={{ fontSize: '17px' }}>{t("NewUser")}</b>
          <div style={{ fontSize: '14px', marginTop: '6px' }}>{t("CreateAndConfigureUser")} </div>
        </div>

        <div className='divGridCreateUser'>
          <div>
            <M_InputTextField
              label={t("Name")}
              value={userInfo?.Username || ''}
              disabled={operation === 'View'}
              onChange={(e) => setUserInfo({ ...userInfo, Username: e.target.value })}
            />
          </div>
          <div>
            <M_InputTextField
              label={t("Email")}
              value={userInfo?.Email || ''}
              disabled={operation === 'View'}
              onChange={(e) => setUserInfo({ ...userInfo, Email: e.target.value })}
            />
          </div>
          <div>
            <M_InputTextField
              label={t("Phone")}
              value={userInfo?.PhoneNumber || ''}
              disabled={operation === 'View'}
              onChange={(e) => setUserInfo({ ...userInfo, PhoneNumber: e.target.value })}
            />
          </div>
        </div>

        <div style={{ marginTop: 25 }}>
          <b style={{ fontSize: '17px' }}>{t("userType")}</b>
        </div>

        <div className="userTypeContainer">
          <div
            className={`userTypeCard ${userType === 'internal' ? 'active' : ''} ${operation === 'View' ? 'disabled' : ''}`}
            onClick={() => {
              if (operation === 'View') return
              setUserType('internal')
              setUserRoles([])
              setUserInfo(prev => ({ ...prev, CustomerId: null, CustomerName: null }))
            }}
          >
            <div className="userTypeLeft">
              <input
                type="radio"
                checked={userType === 'internal'}
                readOnly
              />

              <div>
                <div className="userTypeTitle">
                  {t("internalUser")}
                </div>

                <div className="userTypeSubtitle">
                  {t("CorporateStaffFullAccess")}
                </div>
              </div>
            </div>

            <i className="pi pi-id-card userTypeIcon"></i>
          </div>


          <div
            className={`userTypeCard ${userType === 'client' ? 'active' : ''} ${operation === 'View' ? 'disabled' : ''}`}
            onClick={() => {
              if (operation === 'View') return
              setUserType('client')
              setUserRoles([])
            }}
          >
            <div className="userTypeLeft">
              <input
                type="radio"
                checked={userType === 'client'}
                readOnly
              />

              <div>
                <div className="userTypeTitle">
                  {t("Customer")}
                </div>

                <div className="userTypeSubtitle">
                  {t("ExternalCustomerGuest")}
                </div>
              </div>
            </div>

            <i className="pi pi-users userTypeIcon"></i>
          </div>

        </div>

        {!userType && (
          <div className="emptyHint">
            {t("SelectTypeOfUser")}
          </div>
        )}


        <div>
          {userType === 'internal' && (
            <div style={{ display: 'flex', width: '100%', padding: '40px 0px 10px 0px', justifyContent: 'center' }}>
              <M_TransferList
                disabled={isView}
                header={t("LabelUserRoles")}
                entity={'role'}
                field={'Name'}
                valueIdField={'Id'}
                value={userRoles}
                setValue={setUserRoles}
              />
            </div>
          )}


          {userType === 'client' && (
            <>
              <div style={{ marginTop: 25 }}>
                <M_DrawerTableTextField
                  tableLabel={"Customers"}
                  label={"Customers"}
                  required={true}
                  entity={"Customer"}
                  value={userInfo["CustomerId"] ?
                    {
                      "CustomerId": userInfo["CustomerId"],
                      "ShortName": userInfo["ShortName"] || ''
                    } : null}
                  filterField={"ShortName"}
                  labelFields={["ShortName"]}
                  onSubmitValue={obj => {
                    if (obj) {
                      setUserInfo(prev => ({
                        ...prev,
                        ShortName: obj["ShortName"] || '',
                        CustomerId: obj["CustomerId"]
                      }))
                    } else {
                      setUserInfo(prev => ({
                        ...prev,
                        ShortName: null,
                        CustomerId: null
                      }))
                    }
                  }}
                  disabled={isView}
                />
              </div>

              <div style={{ display: 'flex', width: '100%', padding: '40px 0px 10px 0px', justifyContent: 'center' }}>
                <M_TransferList
                  disabled={isView}
                  header={t("LabelUserRoles")}
                  entity={'role'}
                  field={'Name'}
                  valueIdField={'Id'}
                  value={userRoles}
                  setValue={setUserRoles}
                  filter='isExternal=true'
                />
              </div>
            </>
          )}

        </div>
      </div>
    </div>
  )
}
